import script from "./GeetestCaptcha.vue?vue&type=script&lang=ts&setup=true"
export * from "./GeetestCaptcha.vue?vue&type=script&lang=ts&setup=true"

import "./GeetestCaptcha.vue?vue&type=style&index=0&id=2839305e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2839305e"]])

export default __exports__